import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const { user } = useAuth();
  const [content, setContent] = useState(null);
  const [state, setState] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    if (!user) {
      setContent(null);
      setState(null);
      return;
    }
    Promise.all([api.get("/content"), api.get("/state")]).then(([c, s]) => {
      setContent(c.data);
      setState(s.data);
    });
  }, [user]);

  const saveContent = useCallback(async (key, data) => {
    setContent((prev) => ({ ...prev, [key]: data }));
    await api.put(`/content/${key}`, { data });
  }, []);

  const updateState = useCallback((updater) => {
    setState((prev) => {
      const next = typeof updater === "function" ? updater(prev) : { ...prev, ...updater };
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        api.put("/state", { data: next }).catch(() => {});
      }, 400);
      return next;
    });
  }, []);

  return (
    <DataContext.Provider value={{ content, state, saveContent, updateState }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
